import { connect } from 'react-redux';
import { getAddress } from 'shared/account/reducer';
import { updateAddress, deleteAddress } from 'researcher/user/actions';
import withRouter from 'shared/helper/with-router';
import SavedAddresses from './SavedAddresses';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var account = _ref.account,
    user = _ref.user;
  var match = _ref2.match;
  return {
    address: getAddress({
      user: user,
      match: match
    }),
    addresses: user.addresses,
    countries: account.countries,
    match: match
  };
};
var mapDispatchToProps = {
  deleteAddress: deleteAddress,
  updateAddress: updateAddress
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SavedAddresses));